import clsx from 'clsx'
import { Fragment, FunctionComponent, useState } from 'react'
import { isDeadlineEnabled } from '../utilities/isDeadlineEnabled'
import { useAdminPageData } from '../utilities/useAdminPageData'
import { AdminHeadMonth } from './AdminHeadMonth'
import { AdminShiftTile } from './AdminShiftTile'
import styles from './AdminTimetable.module.sass'

const weekdayShortSundayLast = ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'] as const

type AdminTimetableProps = {
	venue: NonNullable<ReturnType<typeof useAdminPageData>['data']>['getVenue']
	updateData: () => Promise<void>
	isLoading: boolean
}

export const AdminTimetable: FunctionComponent<AdminTimetableProps> = ({
	venue,
	updateData,
	isLoading,
}) => {
	const [_change, setChange] = useState(false)

	return (
		<div className={clsx(styles.wrapper, isLoading && styles.is_loading)}>
			{weekdayShortSundayLast.map((day) => (
				<div key={day} className={styles.weekday}>
					{day}
				</div>
			))}
			<div className={styles.bottomLine}></div>

			<div className={styles.headerWrapper}>
				<div className={styles.monthDeadline}>
					<AdminHeadMonth />
				</div>
			</div>

			{venue?.timetableDays.map((day) => {
				const deadlineTemplate = venue?.deadlineTemplate
				return (
					<Fragment key={day.id}>
						{!isLoading && (
							<AdminShiftTile
								day={day}
								employeeRoles={venue.employeeRoles}
								setChange={setChange}
								updateData={updateData}
								isDeadlineEnabled={isDeadlineEnabled(deadlineTemplate)}
								unassignReasons={venue.enabledUnassignReasons}
							/>
						)}
					</Fragment>
				)
			})}
		</div>
	)
}
